import React from 'react';
import GrnForm from './GrnForm'; // Adjust path
import { useSearchParams } from 'react-router-dom';

const NewGrnPage = () => {
    // Read source_type and source_id from URL query parameters
    const [searchParams] = useSearchParams();
    const sourceType = searchParams.get('source_type');
    const sourceId = searchParams.get('source_id');

    return (
        <GrnForm
            formType="create"
            currentGrnId={null}
            sourceType={sourceType} // Pass to form
            sourceId={sourceId}     // Pass to form
        />
    );
};
export default NewGrnPage;